// import moment from 'moment'
import config from "../const/config"
export default {
  methods: {
    //--------------------------
    // チェック
    //--------------------------

    // 値が半角英数の場合はtrueを返す（空文字はOK,半角スペースはNG）
    isHanEisu: function (str) {
      str = (str == null) ? "" : str;
      if (str.match(/^[A-Za-z0-9]*$/)) {
        return true;
      } else {
        return false;
      }
    },

    //文字列空チェック
    isNullOrEmpty: function (value) {
      if (value == null || value === "") {
        return true;
      }
      return false;
    },

    //桁数チェック
    checkDigits: function (str, digits) {
      if (str == null || digits == "") {
        return false;
      }
      if (str.length == digits) {
        return true;
      } else {
        return false;
      }
    },

    //--------------------------
    // データ変換
    //--------------------------
    //分 → 時間と分を取得
    timeConvertMinToHourMin: function (baseMin) {
      let houre = Math.floor(baseMin / 60);
      let min = baseMin % 60;
      return {
        houre: houre,
        min: min
      }
    },
    //分を日時(hh:mm)に変換
    timeConvertMinToPercentage: function (baseMin) {
      let houre = Math.floor(baseMin / 60);
      let min = baseMin % 60;
      min = min / 60 * 100;
      return houre + "." + this.zeroPadding(min, 2);
    },
    //ハイフン置換
    replaceHyphen: function (str, replaveStr) {
      if (!str) {
        return null
      } else {
        return str.replace(/-/g, replaveStr);
      }
    },
    //0埋め
    zeroPadding: function (num, length) {
      return ('000000000000' + num).slice(-length);
    },

    //--------------------------
    // メッセージ表示 alert
    //--------------------------
    //警告
    showAlertWorningAlert: function (msg = "", title = "") {
      this.$alert(msg, title, {
        confirmButtonText: "OK",
        type: "worning",
        customClass:"editCheckModalWidthHeader"
      });
    },
    //エラー
    // showAlertError: function (msg = "", title = "エラー") {
    showAlertError: function (msg = "", title = "確認") {
      this.$alert(msg, title, {
        confirmButtonText: "OK",
        type: "error",
        customClass:"editCheckModalWidthHeader"
      }).then(() => {

      }).catch(() => {

      })
    },
    //エラー(HTML対応)
    showAlertErrorHTML: function (msg = "", title = "確認") {
      msg = msg.replace(/\r\n/g,'<br>');
      this.$alert(msg, title, {
        confirmButtonText: "OK",
        type: "error",
        customClass:"editCheckModalWidthHeader",
        dangerouslyUseHTMLString: true,
      }).then(() => {

      }).catch(() => {

      })
    },
    //入力エラー
    showAlertValidationError: function (msg = "入力エラーがあります。", title = "エラー") {
      this.$alert(msg, title, {
        confirmButtonText: config.VALUE.OK,
        type: config.VALUE.ALERT_TYPE_ERROR,
        customClass:"editCheckModalWidthHeader"
      }).then(() => {

      }).catch(() => {

      })
    },
    //更新成功
    showAlertUpdateSuccess: function (msg = "成功しました。", title = "更新") {
      this.$alert(msg, title, {
        confirmButtonText: "OK",
        type: "success",
        customClass:"editCheckModalWidthHeader"
      });
    },
    //登録成功
    showAlertRegistSuccess: function (msg = "成功しました。", title = "登録") {
      this.$alert(msg, title, {
        confirmButtonText: "OK",
        type: "success",
        customClass:"editCheckModalWidthHeader"
      });
    },
    //--------------------------
    // メッセージ表示 toast
    //--------------------------
    //エラー
    showToastError: function (msg = "エラーが発生しました", title = "エラー") {
      this.$bvToast.toast(msg, {
        title: title,
        variant: 'danger',
        solid: true
      });
    },
    //サーバー通信エラー
    showToastServerError: function (error = "", title = "サーバ通信エラー") {
      console.trace(title);
      console.trace(error);
      // this.$bvToast.toast(config.MESSAGE.SERVER_ERROR, {
      //   title: title,
      //   variant: 'danger',
      //   solid: true
      // });
    },
    //成功
    showToastSuccess: function (msg = "", title = "") {
      this.$bvToast.toast(msg, {
        title: title,
        variant: 'success',
        solid: true
      });
    },
  }
}